import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QuantityDialogComponent } from '@app/shared/quantity-dialog/quantity-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [QuantityDialogComponent],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, MatFormFieldModule, MatButtonModule, MatInputModule],
  exports: [QuantityDialogComponent],
})
export class QuantityDialogModule {}
